import config from 'config';
import authHeader from '../helpers/authHeaders';

export const seatBlockService = {
  list,
  create,
  delete: _delete,
  getLogs,
};

function getQueryString(params) {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .filter(k => params[k] != null && params[k] !== '')
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&');
}

function list(filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const qs = filters && Object.keys(filters).length ? `?${getQueryString(filters)}` : '';
  return fetch(`${config.apiUrl}/schedule/seats/blocks${qs}`, requestOptions).then(handleResponse);
}

function create(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  };
  return fetch(`${config.apiUrl}/schedule/seats/block`, requestOptions).then(handleResponse);
}

function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };
  return fetch(`${config.apiUrl}/schedule/seats/block/${id}`, requestOptions).then(handleResponse);
}

function getLogs({ schedule_bus, slot, limit, offset }) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const qs = getQueryString({ schedule_bus, slot, limit, offset });
  return fetch(`${config.apiUrl}/schedule/seats/block-logs?${qs}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text ? safeParse(text) : {};
    if (!response.ok) {
      const error = { status: response.status, ...(typeof data === 'object' ? data : { error: data }) };
      return Promise.reject(error);
    }
    return data;
  });
}

function safeParse(text) {
  try { return JSON.parse(text); } catch (_e) { return text; }
}
